<template>
  <div class="top-hero2">
    <div class="container">
      <div id="challange-target">hidden</div>

      <main class="marginTop">
        <div
          class="bg-white py-8 rounded-md max-w-3xl mx-auto grid grid-cols-1 gap-6 sm:px-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3 relative"
        >
          <span
            @click="redirectCrm"
            class="cursor-pointer absolute top-1 left-1 z-20 flex uppercase font-bold sm:bg-gray-100 px-3 rounded-lg"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 text-red-500 mr-1"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z"
                clip-rule="evenodd"
              />
            </svg>
            CRM
          </span>

          <div class="space-y-6 lg:col-start-3 lg:col-span-1">
            <div
              v-if="
                message.repeating_message == 0 && message.deliver_date == null
              "
            >
              <div class="bg-gray-900 py-8 px-4 shadow sm:rounded-lg sm:px-10">
                <form
                  @submit.prevent="messageUpdate(message)"
                  class="space-y-6"
                  action="#"
                  method="POST"
                >
                  <div>
                    <div class="text-center">
                      <p
                        class="text-sm font-extrabold text-indigo-600 sm:text-2xl sm:tracking-tight"
                      >
                        Assign Deliver date
                      </p>
                      <p class="-mt-4 mx-auto text-sm text-gray-300">
                        When should this message send?
                      </p>
                    </div>
                    <v-divider dark></v-divider>
                    <div
                      v-if="picker3 === ''"
                      class="mt-4 flex items-center justify-between"
                    >
                      <div class="flex align-center">
                        <v-checkbox dark v-model="messageRepeated"></v-checkbox>
                        <span class="text-gray-50 -ml-2 text-sm"
                          >Will this message be repeated?</span
                        >
                      </div>
                    </div>

                    <div v-if="messageRepeated" class="mt-1 text-center">
                      <v-date-picker v-model="dates" multiple></v-date-picker>

                      <v-menu
                        ref="menu"
                        v-model="menu2"
                        :close-on-content-click="false"
                        :return-value.sync="dates"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-combobox
                            class="mt-4"
                            dark
                            v-model="dates"
                            multiple
                            chips
                            small-chips
                            label="Multiple picker in menu"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-combobox>
                        </template>
                        <v-date-picker
                          v-model="dates"
                          multiple
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu2 = false">
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.menu2.save(dates)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </div>

                    <div class="-mt-4" v-if="!messageRepeated">
                      <div class="form-group">
                        <input
                          class="form-control"
                          v-model="picker3"
                          type="datetime-local"
                          id="example-datetime-local-input"
                        />
                      </div>
                    </div>

                    <v-btn
                      type="submit"
                      class="-mt-2 float-right"
                      x-small
                      color="info"
                      elevation="2"
                      rounded
                    >
                      Update</v-btn
                    >
                  </div>
                </form>
              </div>
            </div>

            <div v-if="message.repeating_message == 1">
              <div class="bg-gray-900 py-8 px-4 shadow sm:rounded-lg sm:px-10">
                <form
                  @submit.prevent="messageUpdate(message)"
                  class="space-y-6"
                  action="#"
                  method="POST"
                >
                  <div>
                    <div class="text-center">
                      <p
                        class="text-sm font-extrabold text-gray-50 sm:text-2xl sm:tracking-tight"
                      >
                        Check Repeating Dates
                      </p>
                      <p class="-mt-4 mx-auto text-sm text-indigo-600">
                        Add more | Remove
                      </p>
                    </div>
                    <v-divider dark></v-divider>

                    <div class="-mt-2 flex align-center">
                      <v-checkbox dark v-model="messageRepeated"></v-checkbox>
                      <span class="text-gray-50 -ml-2 text-sm"
                        >Click to add more</span
                      >
                    </div>

                    <div v-if="messageRepeated" class="mt-1 text-center">
                      <v-date-picker v-model="dates" multiple></v-date-picker>

                      <v-menu
                        ref="menu"
                        v-model="menu2"
                        :close-on-content-click="false"
                        :return-value.sync="dates"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-combobox
                            class="mt-4"
                            dark
                            v-model="dates"
                            multiple
                            chips
                            small-chips
                            label="Multiple picker in menu"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-combobox>
                        </template>
                        <v-date-picker
                          v-model="dates"
                          multiple
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu2 = false">
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.menu2.save(dates)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>

                      <v-btn
                        type="submit"
                        class="-mt-2 float-right"
                        x-small
                        color="info"
                        elevation="2"
                        rounded
                      >
                        Update</v-btn
                      >
                    </div>
                  </div>
                </form>

                <div class="mt-1 text-sm text-gray-900">
                  <span v-for="deliver in message.repeats" :key="deliver.id">
                    <span
                      v-if="deliver.recurrent_day > actualDate"
                      class="flex px-3 py-0.5 rounded-full text-sm font-light bg-green-100 text-green-800"
                    >
                      {{ deliver.recurrent_day }}
                      <button
                        type="button"
                        @click="removeDate(deliver)"
                        class="ml-4 text-indigo-600 hover:text-indigo-900"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-5 w-5 text-red-600"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 000 2h6a1 1 0 100-2H7z"
                            clip-rule="evenodd"
                          />
                        </svg>
                      </button>
                    </span>

                    <span
                      v-else
                      class="items-center px-3 py-0.5 rounded-full text-sm font-light bg-red-100 text-red-800"
                    >
                      {{ deliver.recurrent_day }}
                    </span>
                  </span>
                </div>
              </div>
            </div>

            <div class="p-4 bg-gray-900 shadow sm:rounded-lg">
              <div class="text-center">
                <h2
                  class="text-base font-semibold text-indigo-600 tracking-wide uppercase"
                >
                  Create
                </h2>
                <p
                  class="-mt-1 text-sm font-extrabold text-gray-50 sm:text-2xl sm:tracking-tight"
                >
                  Email Template
                </p>
                <p class="mt-4 mx-auto text-sm text-gray-300">
                  Start building for free, then add a site plan to go live.
                  Account plans unlock additional features.
                </p>
              </div>

              <v-btn
                @click="blackColor = !blackColor"
                class="mx-2 border"
                fab
                dark
                x-small
                color="#000000"
              ></v-btn>
              <v-btn
                @click="blueColor = !blueColor"
                class="mx-2"
                fab
                dark
                x-small
                color="#03A9F4"
              ></v-btn>
              <v-btn
                @click="defaultColor = !defaultColor"
                class="mx-2"
                fab
                dark
                x-small
                color="#FAFAFA"
              ></v-btn>
            </div>
          </div>

          <section
            aria-labelledby="timeline-title"
            class="lg:col-start-1 lg:col-span-2 mt-4"
          >
            <v-expansion-panels light inset hover>
              <v-expansion-panel v-if="message.repeating_message == 0">
                <v-expansion-panel-header
                  >Deliver Date</v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <dd
                    v-if="message.deliver_date"
                    class="mt-1 text-sm text-gray-900"
                  >
                    <div class="form-group">
                      <span>
                        <b class="text-red-600">*</b>
                        {{ message.deliver_date }}
                      </span>
                      <input
                        class="form-control"
                        v-model="message.deliver_date"
                        type="datetime-local"
                        id="example-datetime-local-input"
                      />
                    </div>

                    <v-btn
                      @click="updateMessage(message)"
                      class="-mt-2 float-right"
                      x-small
                      color="info"
                      elevation="2"
                      rounded
                    >
                      Save</v-btn
                    >
                  </dd>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header
                  >Tags:
                  <span
                    class="text-indigo-500 font-bold rounded-full"
                    v-if="message.tags"
                  >
                    {{ message.tags.length }}</span
                  ></v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <div
                    class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:-mx-6 md:mx-0 md:rounded-lg"
                  >
                    <v-btn
                      @click="assigTag()"
                      v-if="message.tags.length == 0"
                      color="indigo"
                      dark
                      block
                    >
                      Click to Add tags
                    </v-btn>

                    <table class="min-w-full divide-y divide-gray-300">
                      <thead class="bg-gray-50">
                        <tr>
                          <th
                            scope="col"
                            class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                          >
                            Name
                          </th>
                          <th
                            scope="col"
                            class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell"
                          >
                            Recipients
                          </th>
                          <th
                            scope="col"
                            class="relative py-3.5 pl-3 pr-4 sm:pr-6"
                          >
                            <span class="sr-only">Edit</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody class="divide-y divide-gray-200 bg-white">
                        <tr v-for="tag in message.tags" :key="tag.id">
                          <td
                            class="w-full max-w-0 py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:w-auto sm:max-w-none sm:pl-6"
                          >
                            {{ tag.name }}
                            <dl class="font-normal lg:hidden">
                              <dd class="mt-1 truncate text-gray-700">
                                Recipients: {{ tag.users.length }}
                              </dd>
                            </dl>
                          </td>
                          <td
                            class="hidden px-3 py-4 text-sm text-gray-500 lg:table-cell"
                          >
                            {{ tag.users.length }}
                          </td>
                          <td
                            class="flex py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6"
                          >
                            <a
                              @click="assigTag()"
                              class="text-indigo-600 hover:text-indigo-900"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="h-5 w-5"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                                  clip-rule="evenodd"
                                />
                              </svg>
                            </a>

                            <a
                              @click="displayTag(tag)"
                              class="ml-4 text-indigo-600 hover:text-indigo-900"
                            >
                              <svg
                                class="h-5 w-5 text-green-500"
                                viewBox="0 0 24 24"
                                stroke-width="2"
                                stroke="currentColor"
                                fill="none"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              >
                                <path stroke="none" d="M0 0h24v24H0z" />
                                <path
                                  d="M9 7 h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3"
                                />
                                <path
                                  d="M9 15h3l8.5 -8.5a1.5 1.5 0 0 0 -3 -3l-8.5 8.5v3"
                                />
                                <line x1="16" y1="5" x2="19" y2="8" />
                              </svg>
                            </a>

                            <a
                              @click="removeTag(message, tag)"
                              class="ml-4 text-indigo-600 hover:text-indigo-900"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="h-5 w-5 text-red-500"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                stroke-width="2"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                />
                              </svg>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <div
              v-if="message.message_type == '0'"
              class="mt-2 shadow-xl px-4 py-5 shadow sm:rounded-lg sm:px-6"
            >
              <div class="text-center">
                <v-text-field
                  label="Message Name"
                  outlined
                  v-model="message.message_name"
                ></v-text-field>
              </div>

              <!-- Activity Feed -->
              <div class="flow-root">
                <div
                  :class="myClass"
                  class="flex flex-col rounded-lg shadow-lg overflow-hidden"
                >
                  <!-- <div class="p-6">
                      <blockquote class="mt-6 md:flex-grow md:flex md:flex-col">
                        <div
                          :class="myClass"
                          class="relative text-center text-lg font-medium text-gray-600 md:flex-grow"
                        >
                          <svg
                            class="absolute top-0 left-0 transform -translate-x-3 -translate-y-2 h-8 w-8 text-gray-200"
                            fill="currentColor"
                            viewBox="0 0 32 32"
                            aria-hidden="true"
                          >
                            <path
                              d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z"
                            />
                          </svg>
                          <p class="relative">
                            360 Real Estate is a full service brokerage firm
                            able to buy, sell, or rent and manage residential
                            and commercial properties.
                          </p>
                        </div>
                      </blockquote>
                    </div> -->

                  <div class="flex-shrink-0">
                    <img
                      class="h-48 w-full object-cover"
                      src="https://homesby360.s3.amazonaws.com/temp.jpg"
                      alt=""
                    />
                  </div>
                  <div
                    :class="myClass"
                    class="flex-1 p-6 flex flex-col justify-between"
                  >
                    <div :class="myClass" class="flex-1">
                      <v-textarea
                        v-model="message.message_body"
                        outlined
                        name="input-7-4"
                        label="Message body"
                      ></v-textarea>

                      <div class="flex justify-end">
                        <a
                          @click="updateMessage(message)"
                          class="px-3 py-0.5 rounded-full text-sm font-medium bg-blue-100"
                        >
                          Update
                        </a>

                        <a @click="removeMessage(message)">
                          <span
                            class="ml-2 px-3 py-0.5 rounded-full text-sm font-medium bg-red-100 text-red-800"
                          >
                            Delete
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>

                  <blockquote
                    class="bg-gray-100 mt-6 md:flex-grow md:flex md:flex-col"
                  >
                    <div
                      class="mt-2 relative text-center text-xs font-medium text-gray-600 md:flex-grow"
                    >
                      <p class="relative">
                        This email template was sent to you because we want to
                        <br />provide information you might need.<br />
                      </p>
                    </div>
                  </blockquote>
                </div>
              </div>
            </div>
            <div
              v-else
              class="px-2 py-2 bg-white shadow overflow-hidden sm:rounded-md"
            >
              <div class="mt-2">
                <p>SMS Template</p>

                <div class="flex flex-col rounded-lg shadow-lg overflow-hidden">
                  <div
                    class="flex-1 bg-white p-6 flex flex-col justify-between"
                  >
                    <div :class="myClass" class="flex-1">
                      <v-textarea
                        v-model="message.message_body"
                        outlined
                        name="input-7-4"
                        label="Message body"
                      ></v-textarea>

                      <div class="flex justify-end">
                        <a
                          @click="updateMessage(message)"
                          class="px-3 py-0.5 rounded-full text-sm font-medium bg-blue-100"
                        >
                          Update
                        </a>

                        <a @click="removeMessage(message)">
                          <span
                            class="ml-2 px-3 py-0.5 rounded-full text-sm font-medium bg-red-100 text-red-800"
                          >
                            Delete
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>

                  <blockquote
                    class="bg-gray-100 mt-6 md:flex-grow md:flex md:flex-col"
                  >
                    <div
                      class="mt-2 relative text-center text-xs font-medium text-gray-600 md:flex-grow"
                    >
                      <p class="relative">
                        This SMS was sent to you because we want to
                        <br />provide information you might need.<br />
                      </p>
                    </div>
                  </blockquote>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>

      <!-- Modal -->
      <!-- This example requires Tailwind CSS v2.0+ -->
      <div class="fixed z-10  inset-0 overflow-y-auto" v-if="isOpen">
        <div
          class=" flex items-end justify-center pt-4 px-4 pb-20 text-center sm:block sm:p-0"
        >
          <div class="fixed inset-0 transition-opacity" aria-hidden="true">
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span
            class="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
            >&#8203;</span
          >

          <div
            class="inline-block bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all align-middle"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
          >
            <div class="px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <h3
                class="text-lg leading-6 font-medium text-gray-900"
                id="modal-headline"
              >
                Contacts in this tag ( {{ openTag.name }} )
              </h3>
              <div class="mt-2">
                <!-- This example requires Tailwind CSS v2.0+ -->
                <div class="flex flex-col">
                  <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div
                      class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8"
                    >
                      <div
                        class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
                      >
                        <table class="min-w-full divide-y divide-gray-200">
                          <thead class="bg-gray-50">
                            <tr>
                              <th
                                scope="col"
                                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                              >
                                Name
                              </th>
                              <th
                                scope="col"
                                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                              >
                                Title
                              </th>

                              <th
                                scope="col"
                                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                              >
                                Actions
                              </th>
                            </tr>
                          </thead>
                          <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="user in openTag.users" :key="user.id">
                              <td class="px-6 py-4 whitespace-nowrap">
                                <div class="flex items-center">
                                  <div class="flex-shrink-0 h-10 w-10">
                                    <img
                                      class="h-10 w-10 rounded-full"
                                      :src="url + user.name + rest"
                                      alt=""
                                    />
                                  </div>
                                  <div class="ml-4">
                                    <div
                                      class="text-sm font-medium text-gray-900"
                                    >
                                      {{ user.name }}
                                    </div>
                                    <div class="text-sm text-gray-500">
                                      {{ user.email }}
                                    </div>
                                  </div>
                                </div>
                              </td>
                              <td class="px-6 py-4 whitespace-nowrap">
                                <div class="text-sm text-gray-900">
                                  {{ user.phone }}
                                </div>
                              </td>

                              <td
                                class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium"
                              >
                                <a
                                  href="#"
                                  v-if="openTag.users.length > 1"
                                  @click="removeContact(user, openTag)"
                                  class="text-red-600 hover:text-red-900"
                                  >Remove</a
                                >
                              </td>
                            </tr>

                            <!-- More items... -->
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse"
                >
                  <button
                    type="submit"
                    class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-primary text-white font-medium hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                  >
                    Save
                  </button>
                  <button
                    @click="hideTag()"
                    type="button"
                    class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- close Modal -->

      <!-- This example requires Tailwind CSS v2.0+ -->
      <div class="fixed z-10  inset-0 overflow-y-auto" v-if="isOpenTag">
        <div
          class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
        >
          <div class="fixed inset-0 transition-opacity" aria-hidden="true">
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span
            class="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
            >&#8203;</span
          >

          <div
            class="inline-block bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all align-middle"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
          >
            <div class="px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <h3
                class="text-lg leading-6 font-medium text-gray-900"
                id="modal-headline"
              >
                Message Delivers
              </h3>
              <div class="mt-2">
                <p class="text-sm text-gray-500">
                  Remove a deliver date from the message
                </p>

                <!-- This example requires Tailwind CSS v2.0+ -->
                <div class="flex flex-col">
                  <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div
                      class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8"
                    >
                      <div
                        class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
                      >
                        <table class="min-w-full divide-y divide-gray-200">
                          <thead class="bg-gray-50">
                            <tr>
                              <th
                                scope="col"
                                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                              >
                                Name
                              </th>
                              <th
                                scope="col"
                                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                              >
                                Created At
                              </th>
                              <th
                                scope="col"
                                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                              >
                                Actions
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <!-- Odd row -->
                            <tr
                              v-for="deliver in message.repeats"
                              :key="deliver.id"
                              class="bg-white"
                            >
                              <td
                                class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                              >
                                {{ deliver.recurrent_day }}
                              </td>
                              <td
                                class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                              >
                                <span
                                  v-if="deliver.recurrent_day > actualDate"
                                  class="px-2 inline-flex text-xs leading-5 font-light rounded-full bg-green-100 text-green-800"
                                >
                                  Sending...
                                </span>
                                <span
                                  v-else
                                  class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-light bg-red-100 text-red-800"
                                >
                                  Sent
                                </span>
                                <!-- {{ deliver.recurrent_day }} {{ picker2 }} -->
                              </td>

                              <td
                                class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium"
                              >
                                <a
                                  v-if="deliver.recurrent_day > actualDate"
                                  @click="removeDate(deliver, message)"
                                  class="text-rose-600 hover:text-rose-900"
                                  >Remove</a
                                >
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse"
                >
                  <button
                    @click="isOpenTag = false"
                    type="button"
                    class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- close Modal -->

      <!-- Modal -->
      <!-- This example requires Tailwind CSS v2.0+ -->
      <div class="fixed z-10  inset-0 overflow-y-auto" v-if="tagAssign">
        <div
          class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
        >
          <div class="fixed inset-0 transition-opacity" aria-hidden="true">
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span
            class="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
            >&#8203;</span
          >

          <div
            class="md:text-left h-full w-full inline-block bg-white rounded-lg text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
          >
            <div class="px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <h3
                class="text-lg leading-6 font-medium text-gray-900"
                id="modal-headline"
              >
                Assign more tags
              </h3>
              <div class="mt-2">
                <v-form @submit.prevent="saveMessageTag()">
                  <div class="form-group">
                    <label class="text-sm" for="name">Tag Name:</label>
                    <!--  -->
                    <multiselect
                      v-model="tagsSelected"
                      :options="tags"
                      :multiple="true"
                      :close-on-select="true"
                      :clear-on-select="true"
                      :preserve-search="true"
                      label="name"
                      track-by="id"
                      :preselect-first="false"
                    >
                    </multiselect>
                  </div>

                  <div
                    class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse"
                  >
                    <button
                      type="submit"
                      class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-primary text-white font-medium hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                    >
                      Save
                    </button>
                    <button
                      @click="tagAssign = false"
                      type="button"
                      class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                    >
                      Cancel
                    </button>
                  </div>
                </v-form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- close Modal -->
    </div>
  </div>
</template>

<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>

<script>
import Multiselect from "vue-multiselect";
import Swal from "sweetalert2";
import moment from "moment";
export default {
  components: {
    Multiselect
  },

  props: {
    source: String
  },

  data() {
    return {
      id: this.$route.params.id,
      message: {},
      url: "https://ui-avatars.com/api/?name=",
      rest: "&background=ccf3ff&color=0099cc",
      isOpen: false,
      openTag: "",

      menu: false,
      tagAssign: false,
      isOpenTag: false,
      actualDate: moment().format("YYYY-MM-DD"),

      tags: [],
      tagsSelected: [],

      blackColor: false,
      blueColor: false,
      defaultColor: false,

      picker2: new Date().toISOString().substr(0, 10),
      picker3: "",
      dates: [new Date().toISOString().substr(0, 10)],
      menu2: false,
      messageRepeated: ""
    };
  },

  created() {
    this.fullMessage();
  },

  computed: {
    myClass() {
      if (this.blackColor) {
        return "bg-dark text-white";
      } else if (this.blueColor) {
        return "bg-info text-white";
      } else if (this.defaultColor) {
        return "bg-white text-gray-800";
      }
    },

    totalUsers() {
      let total = [];
      Object.entries(this.message.tags).forEach(([key, val]) => {
        total.push(val.users.length); // the value of the current key.
      });

      return total.reduce(function(a, b) {
        return a + b;
      }, 0);
    }
  },

  methods: {
    redirectCrm() {
      this.$router.push({ name: "CRM" });
    },

    messageUpdate(message) {
      let updateMessage = new FormData();

      $.each(this.dates, function(key, value) {
        updateMessage.append(`dates[${key}]`, value);
      });

      updateMessage.append("messageId", message.id);
      updateMessage.append("picker2", this.picker3);
      updateMessage.append("messageRepeated", this.messageRepeated);

      window.axios.post("/api/updateMessage", updateMessage).then(() => {
        // this.$emit("event");
        this.messageRepeated = "";
        this.picker3 = "";
        this.dates = [new Date().toISOString().substr(0, 10)];
        Swal.fire({
          icon: "success",
          title: "Date successfully added"
        });
        this.fullMessage();
      });
    },

    assigTag() {
      window.axios
        .post("/api/messageTags", {
          tags: this.message.tags
        })
        .then(response => {
          this.tags = response.data;
        });
      this.tagAssign = true;
    },

    saveMessageTag() {
      let updateMessage = new FormData();

      $.each(this.tagsSelected, function(key, value) {
        updateMessage.append(`tagIds[${key}]`, value.id);
      });

      updateMessage.append("messageId", this.message.id);
      window.axios.post("/api/saveMessageTag", updateMessage).then(() => {
        this.tagAssign = false;
        this.tags = [];
        Swal.fire({
          icon: "success",
          title: "Message successfully updated"
        });
        this.fullMessage();
      });
    },

    fullMessage() {
      window.axios.get("/api/getMessage/" + this.id).then(res => {
        this.message = res.data;
      });
    },

    displayTag(tag) {
      //   window.axios.get("/api/mailgun/" + tag.id).then(res => {
      //    console.log(res.items);
      //  });

      this.isOpen = true;
      this.openTag = tag;
    },

    hideTag() {
      this.openTag = "";
      this.isOpen = false;
    },

    removeContact(user, tag) {
      window.axios
        .post("/api/removeUserTag", {
          userId: user.id,
          tagId: tag.id
        })
        .then(() => {
          this.openTag = "";
          this.isOpen = false;
          this.fullMessage();
          Swal.fire({
            icon: "success",
            title: "User successfully removed"
          });
        });
    },

    updateMessage(message) {
      window.axios
        .post("/api/messageUpdate/" + message.id, {
          name: message.message_name,
          body: message.message_body,
          deliver: message.deliver_date
        })
        .then(() => {
          this.fullMessage();
          Swal.fire({
            icon: "success",
            title: "Message successfully updated"
          });
        });
    },

    removeDate(deliver) {
      window.axios
        .post("/api/removeDatetime", {
          deliverId: deliver.id
        })
        .then(() => {
          this.isOpenTag = false;
          this.fullMessage();
        });
    },

    removeMessage(message) {
      window.axios
        .post("/api/messageDelete", {
          messageId: message.id
        })
        .then(res => {
          if (res.data == "error") {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "You can't delete message with tags"
            });
          } else if (res.data == "Done") {
            Swal.fire({
              icon: "success",
              title: "Message successfully deleted"
            });
            this.$router.push({ name: "CRM" });
          }
        });
    },

    removeTag(message, tag) {
      window.axios
        .post("/api/removeMessageTag", {
          messageId: message.id,
          tagId: tag.id
        })
        .then(res => {
          if (res.data === "error") {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Messages need to have minimun tag"
            });
          } else {
            Swal.fire({
              icon: "success",
              title: "Tag successfully removed"
            });

            this.fullMessage();
          }
        });
    }
  }
};
</script>
